import { FEEDBACK_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const feedbackApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postFeedbackRequest: builder.mutation({
      query: (requestData) => ({
        url: `${FEEDBACK_URL}/feedback`,
        method: "POST",
        body: requestData,
      }),
    }),

    getFeedbackRequest: builder.query({
      query: () => ({
        url: `${FEEDBACK_URL}/feedback`,
        method: "GET",
      }),
      providesTags: ["feedback"],
    }),

    getFeedbackRequestById: builder.query({
      query: (id) => ({
        url: `${FEEDBACK_URL}/feedback/${id}`,
        method: "GET",
      }),
      providesTags: ["feedback"],
    }),

    // ✅ NEW: Fetch feedback by academy ID
    getFeedbackByAcademy: builder.query({
      query: (academyId) => ({
        url: `${FEEDBACK_URL}/feedback/academy/${academyId}`,
        method: "GET",
      }),
      providesTags: ["feedback"],
    }),

    deleteFeedbackRequest: builder.mutation({
      query: (id) => ({
        url: `${FEEDBACK_URL}/feedback/${id}`,
        method: "DELETE",
        responseHandler: (response) => response.text(),
      }),
      transformResponse: (responseText) => ({ message: responseText }),
      invalidatesTags: ["feedback"],
    }),
  }),
});

export const {
  usePostFeedbackRequestMutation,
  useGetFeedbackRequestQuery,
  useGetFeedbackRequestByIdQuery,
  useGetFeedbackByAcademyQuery, // ✅ new hook
  useDeleteFeedbackRequestMutation,
} = feedbackApiSlice;
